<template>
  <div class = 'main'>
    <div style="height:20px; background-color: #fff;">
    </div>
    <div class="el-main-1">
      <el-row type="flex" class="el-row">
        <el-col :span="8" class ="el-col-1"> 
          <div style="margin: auto; padding: auto; text-align: left">
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:18px;  font-weight:700">通知公告</span>
            <el-link type="warning" @click.native="routeParent('2')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
          </div>
          <ul v-if = "noticeList!= null && noticeList.length > 0" class="tzgg-ul" style="margin-top:15px">
            <li v-for="notice in noticeList" :key="notice.id" class="text tzgg-ul-li"><i class=""></i>
              <a class="" @click="routeFuncDetail(notice.id,'通知公告')">{{ notice.theme }}</a>
              <span class="">{{ notice.createTime }}</span>
            </li>  
          </ul>
          <div v-else class="tzgg-ul" style="display: flex;justify-content: center;"> 
            <el-image :src="empty" fit="cover"    style="width: 400px; height: 250px"  ></el-image>
          </div>
        </el-col>
        <el-col :span="8" class ="el-col-1" > 
          <div class="block">
            <el-carousel height="290px" indicator-position = "none">
              <el-carousel-item v-for="item in imagList" :key="item.id"  @click.native="goOuterWeb(item)"> 
                <img :src = "item.imgUrl" height="290px" width="100%" fit="cover"  />
                <div class="carousel-item-text" >
                  <span>{{ item.remark }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div> 
        </el-col>
       <el-col :span="8" class ="el-col-1" > 
          <div style="margin: auto; padding: auto; text-align: left">
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:18px;  font-weight:700">实验室准入教程</span>
            <i  v-if = "enterState.studyState >= 5" style="color: #67C23A;margin-left:20px" class="el-icon-success"></i>
            <i  style="color: #E6A23C;cursor: pointer; margin-left:10px"  class="el-icon-refresh" @click="refreshEnterState"></i>
          </div>
          <div style="line-height: 50px;text-align: left;">
            <div style="margin-left:10px;cursor: pointer;" >
              <i  v-if = "enterState.studyState >= 1" style="color: #67C23A;" class="el-icon-success"></i>
              <i  v-else class="el-icon-success"></i>
              <span v-if = "regBasicList.length == 0"  @click = "showMessage('未配置实验室准入规章制度！')">实验室准入规章制度</span>
              <el-dropdown v-else @command="handleCommandReg" >
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;" >
                 实验室准入规章制度<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  divided v-for=" item in regBasicList" :command="item.id" :key="item.id">
                    <i v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                    <i v-else class="el-icon-success"></i>
                    {{ item.theme }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> 
            <div style="margin-left:10px;cursor: pointer;" >
              <i v-if = "enterState.studyState >= 2" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span v-if = "knBasicList.length == 0"  @click = "showMessage('未配置实验室准入安全知识！')">实验室准入安全知识</span>
              <el-dropdown v-else  @command="handleCommandKn" >
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;">
                  实验室准入安全知识<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item divided v-for=" item in knBasicList" :command="item.id" :key="item.id">
                    <i  v-if = "item.learned > 0" style="color: #67C23A;" class="el-icon-success"></i>
                    <i v-else class="el-icon-success"></i>
                    {{item.theme}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div style="margin-left:10px;cursor: pointer;">
              <i v-if = "enterState.studyState >= 3" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span @click="goBasicQm">实验室准入知识题库</span>
            </div> 
            <div style="margin-left:10px;cursor: pointer;">
              <i v-if = "enterState.studyState >= 4" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span v-if = "examThemeBasic.id == 0 "  @click="goBasicExam">实验室准入安全考试</span>
              <el-dropdown v-else  @command="handleCommandExam">
                <span class="el-dropdown-link" style="font-size:17px;cursor: pointer;">
                  实验室准入安全考试<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if =  "examThemeBasic.examCount == 1"  divided  :command="1" >
                    <i :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 第1次考试 </i>
                  </el-dropdown-item>
                  <el-dropdown-item v-else  divided v-for=" (item,index) in examThemeBasic.examCount" :command="item" :key="index">
                    <i v-if = " item == 1"  class="el-icon-warning"> 第1次考试 </i>
                    <i v-else-if = "item < examThemeBasic.examCount && item > 1  "  class="el-icon-warning">{{ ' 第' + (item - 1) + '次重考'}} </i>
                    <i v-else :style="examThemeBasic.result ? 'color: #67C23A;':''" :class="examThemeBasic.result? 'el-icon-success':'el-icon-warning'"> 第{{item - 1}}次重考</i>
                  </el-dropdown-item>
                  <el-dropdown-item divided :command="0" v-if = "canReExam && examThemeBasic.result != null && !examThemeBasic.result">
                    <i style="color: #f22004;" class="el-icon-warning" > 重考</i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> 
            <div style="margin-left:10px;cursor: pointer;">
              <i v-if = "enterState.studyState >= 5" style="color: #67C23A;" class="el-icon-success"></i>
              <i v-else class="el-icon-success"></i>
              <span @click="goBasicSafeBook">实验室准入安全责任书</span>
            </div> 
          </div>
        </el-col>
      </el-row>
     
      <div style="margin: auto; margin-top: 40px; padding: auto; width: 1400px;text-align: left">
        <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:18px;  font-weight:700">知识题库</span>
        <el-link type="warning" @click.native="routeParent('3')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
      </div>
      <el-row>
        <el-col style="padding: 20px;" :xs="24" :sm="24" :md="12" :lg="6" :xl="6"  v-for = "(item, index ) in qmList" :key = "index" >
          <div style="background-color:#fff;cursor: pointer;">
            <el-image 
            style="width: 100%; height: 290px ;  cursor: pointer; border-radius: 10px;"
            :src="item.coverImage"
            :fit="fit" @click="goSelfTest(item.id)"></el-image>
            <el-tag type="warning"   @click="goSelfTest(item.id)" class="tzgg-ul" style="width:100%;font-size: 18px;">
              {{ item.moduleName }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
      <div style="margin: auto;margin-top: 100px; padding: auto; width: 1400px;text-align: left">
        <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:18px;  font-weight:700">安全知识</span>
        <el-link type="warning" @click.native="routeParent('4')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
      </div>
      <el-row type="flex" class="row-bg el-row2" style="justify-content: space-between">   
        <el-col :span="5" class="el-col-2"  v-for = "(item) in knModelList.slice(0,4)" :key = "item.id">                                                                                                                                                                                                                                                                                                                                
          <div style="height:250px; border-radius:1px;background-color:#fff; box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
            <!-- <div :style=" 'text-align: center ;font-size:20px; overflow: hidden; height: 30px; background-color:' + knColorList[index] +';' "> -->
              <div :style=" 'text-align: center ;font-size:20px; overflow: hidden; height: 30px; background-color:#00ffff' ">
              {{ item.moduleName }}
            </div>
            <ul class ="m2">
              <li style="overflow:hidden;"  v-for = "(ite) in item.knList.slice(0,4)" :key = "ite.id"><a class=""  @click="routeFuncDetail(ite.id,'安全知识')"  > {{ite.theme}}</a></li>
            </ul>
          </div>   
        </el-col>          
      </el-row>
      <el-row  style="margin-top: 30px;">
        <el-col style="padding: 20px;" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div style="margin: auto; padding: auto; width: 1400px;text-align: left">
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:18px;  font-weight:700">办事指南</span>
            <el-link type="warning" @click.native="routeParent('6')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
          </div>
          <div style="background-color:#fff;margin-top: 30px;cursor: pointer;">
            <el-image 
            style="width: 100%; height: 290px ; border-radius: 10px;"
            :src="guid"
            :fit="fit" @click="routeParent('6')"></el-image>
          </div>
        </el-col>
        <el-col style="padding: 20px;" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div style="margin: auto;  padding: auto; width: 1400px;text-align: left">
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:18px;  font-weight:700">安全管理</span>
            <el-link type="warning" @click.native="routeParent('8')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
          </div>
          <div style="background-color:#fff;margin-top: 30px;     cursor: pointer;">
            <el-image 
            style="width: 100%; height: 290px ; border-radius: 10px;"
            :src="safeManage"
            :fit="fit" @click="routeParent('8')"></el-image>
          </div>
        </el-col>
        <el-col style="padding: 20px;" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div style="margin: auto;  padding: auto; width: 1400px;text-align: left">
            <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
            <span style="font-size:18px;  font-weight:700">安全责任书</span>
            <el-link type="warning" @click.native="routeParent('9')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
          </div>
          <div style="background-color:#fff;margin-top: 30px;cursor: pointer;">
            <el-image 
            style="width: 100%; height: 290px ; border-radius: 10px;"
            :src="safeBook"
            :fit="fit" @click="routeParent('9')"></el-image>
          </div>
        </el-col>
      </el-row>

      <div style="margin: auto; margin-top: 40px;padding: auto; width: 1400px;text-align: left">
        <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:18px;  font-weight:700">规章制度</span>
        <el-link type="warning" @click.native="routeParent('5')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
      </div>
      <el-row type="flex" style="margin-top: 30px; height:200px ;justify-content: space-between">   
        <el-col :span="7" class="" style="margin:25px" >                                                                                                                                                                                                                                                                                                                                
          <div class="layui-row layui-col-space2" style="height:200px; border-radius:10px; box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
            <el-row>
              <el-col :span="1">
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;   height:100px;width: 100%; background-color: #ffb800;border-radius:8px  0 0 8px ;border-right:  solid 2px #ffb800" >
                  <p style="text-align: center ;height: 100px">国家规定</p>
                </div>
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;  height: 96px ;width: 100%;  border-right:  solid 2px #ffb800">
                  <el-link style="text-align: center; height: 96px" type="warning" @click.native="routeParent('5')">更多+  </el-link>
                </div>
              </el-col>
              <el-col :span="5" class="el-col-3">
                <ul class="tzgg-ul" >
                  <li v-for="(item) in regObj.countryList.slice(0,4)"  :key ="item.id" class="text tzgg-ul-li">
                    <i class=""></i>
                    <a class="" @click="routeFuncDetail(item.id,'规章制度')">{{ item.theme }}</a>
                  </li>  
                </ul>
              </el-col>
            </el-row>
          </div>
        </el-col> 
        <el-col :span="7" class=""  style="margin:25px">                                                                                                                                                                                                                                                                                                                                
          <div class="layui-row layui-col-space2" style="height:200px; border-radius:15px;background-color:#fff; box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
            <el-row>
              <el-col :span="1">
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;   height:100px;width: 100%; background-color: #ffb800;border-radius:8px  0 0 8px ;border-right:  solid 2px #ffb800" >
                  <p style="text-align: center ;height: 100px">地方文件</p>
                </div>
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;  height: 96px ;width: 100%;  border-right:  solid 2px #ffb800">
                   <el-link style="text-align: center; height:96px" type="warning" @click.native="routeParent('5')">更多+  </el-link>
                </div>
              </el-col>
              <el-col :span="5" class="el-col-3">
                <ul class="tzgg-ul" >
                  <li v-for="(item) in regObj.localList.slice(0,4)" :key="item.id" class="text tzgg-ul-li">
                    <i class=""></i>
                    <a class="" @click="routeFuncDetail(item.id,'规章制度')">{{ item.theme }}</a>
                  </li>  
                </ul>
              </el-col>
            </el-row>
          </div>
        </el-col>      
        <el-col :span="7" class=""  style="margin:25px">                                                                                                                                                                                                                                                                                                                                
          <div class="layui-row layui-col-space2" style="height:200px; border-radius:15px;background-color:#fff; box-shadow: 3px 3px 3px 3px rgba(39, 93, 105, 0.07)">
            <el-row>
              <el-col :span="1">
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;   height:100px;width: 100%; background-color: #ffb800;border-radius:8px  0 0 8px ;border-right:  solid 2px #ffb800" >
                  <p style="text-align: center ;height: 100px">其余文件</p>
                </div>
                <div style="display: flex; align-items: center; writing-mode: tb-rl; text-orientation: upright;  height: 96px ;width: 100%;  border-right:  solid 2px #ffb800">
                  <el-link style="text-align: center; height: 96px" type="warning" @click.native="routeParent('5')">更多+  </el-link>
                </div>
              </el-col>
              <el-col :span="5" class="el-col-3">
                <ul class="tzgg-ul" >
                  <li v-for="(item) in regObj.otherList.slice(0,4)" :key="item.id" class="text tzgg-ul-li">
                    <i class=""></i>
                    <a class="" @click="routeFuncDetail(item.id,'规章制度')">{{ item.theme }}</a>
                  </li>  
                </ul>
              </el-col>
            </el-row>
          </div>
        </el-col>              
      </el-row>
      <div style="margin: auto; margin-top: 40px; padding: auto; width: 1400px;text-align: left">
        <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
        <span style="font-size:18px;  font-weight:700">个人中心</span>
        <el-link type="warning" @click.native="routeParentSelf('7','0')">更多  <i class="el-icon-d-arrow-right" style="color: #f2853d"></i></el-link>
      </div>
      <div  style="display: flex; width:50%; margin-top: 20px; padding: 10px;">
        <div @click="routeParentSelf('7','1')" style="background-color:#3dd7f2;height: 60px; width :45%;display:flex;  cursor: pointer; margin-left: 20px; align-items: center; justify-content: center;"><i class="el-icon-edit-outline"></i><span>安全考试</span></div>
        <div @click="routeParentSelf('7','2')"  style="background-color:#3dd7f2;height: 60px; width :45% ;margin-left: 10px;cursor: pointer;display:flex; align-items: center; justify-content: center;"><i class = "el-icon-document-delete"> </i> <span>错题集</span></div>
        <div @click="routeParentSelf('7','0')"  style="background-color:#3dd7f2;height: 60px; width :45% ;margin-left: 10px; cursor: pointer;display:flex; align-items: center; justify-content: center; "><i class="el-icon-s-custom"></i> <span>个人信息</span></div>
      </div>
      <el-dialog :visible.sync="dialogVisual.viewQbVisual" fullscreen  v-on:close ="clearViewQbOneDetail" >
        <el-col :span="6" style="">
          <el-card style="height:calc(86vh - 19px);margin-top: 10px; overflow:auto; text-align: left;">
            <div  class="clearfix">
              <el-tag type ="mini">
                {{ viewQbOneDetail.moduleName }}
              </el-tag>
              <span>
                一共{{ viewQbOneDetail.totalCount }}题,已学{{ viewQbOneDetail.learnCount }}题
              </span>
            </div>
            <div style="margin-top: 10px;text-align: left;">
              <el-progress type="circle" :format="funcAnswered" :percentage="viewQbOneDetail.learnPer" :width="70"></el-progress>
              <el-progress type="circle" :format="funcOk" :percentage="viewQbOneDetail.learnOkPer" :width="70" style="margin-left:20px"></el-progress>
            </div>     
            <div v-for = "(item,index) in viewQbOneDetail.qtList" :key="index" style="margin-top:5px">
              <el-tag type ="mini"> {{item.answerCheckType}}</el-tag>
              <div>
                <div style="margin-top : 5px">一共:{{item.count}}题 </div>
                <div style="margin-top : 5px">已学:{{item.learnCount}}题 </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-card style="height:calc(86vh - 18px);text-align:left ; margin-top:10px;margin-left:20px; overflow:auto;">
            <div slot="header" class="clearfix">
              <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
              <el-tag style ="margin-left: 10px;">{{ qbView.moduleName }}</el-tag>
              <el-tag type="success">{{  qbView.answerCheckType }}</el-tag>
              <el-tag :type=" qbView.selected ? 'success' : 'warning'">{{  qbView.selected ? '已作答':'未作答' }}</el-tag>
              <el-button  type="primary"  v-if ="qbView.selected"   style="el-icon--right" @click="recordOneSchedule()" size = "small" icon="">设置为书签 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button  type="danger"  v-if ="qbView.selected && !qbView.resultOk"   style="el-icon--right" @click="recordErrorQb()" size = "small" icon="">加入错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
            <div style ="margin-top: 10px;" >
              <el-tag type="warning">问题</el-tag>
              <span style ="margin-left: 10px;">{{qbView.question }}</span>
            </div>
            <div style ="margin-top: 10px;" v-if = " qbView.imageUrlList.length > 0"> 
              <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
              <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
                <el-image   
                  style="width: 100px; height: 100px;margin-left: 10px; "
                  :src="item.url"
                  :fit="fit">
                </el-image>
              </el-badge>
            </div>
            <div style ="margin-top: 10px;">
              <el-checkbox-group v-model="qbView.checkedOptList" >
                <el-tag type="warning">选项</el-tag>
                <el-checkbox style ="margin-left: 10px;"  :disabled = "qbView.selected" v-for="(opt , index ) in qbView.optionValueArr" :label="String.fromCharCode(65 + index)" :key="index">{{opt}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style ="margin-top: 10px;" v-if ="qbView.selected" >
              <el-tag type="warning">我的答案</el-tag>
              <span style ="margin-left: 10px;">{{qbView.learnAnswer }}</span>
              <el-button  size="mini"  :type="qbView.resultOk ? 'success':'danger'"
               :icon="qbView.resultOk ? 'el-icon-check': 'el-icon-close'" circle></el-button>
            </div>
            <div style ="margin-top: 10px;">
              <el-tag type="warning">操作</el-tag>
              <el-button v-if ="!qbView.selected"   style ="margin-left:10px;" type="primary"   @click="submitAnswer()"  size = "small">提交答案<i class="el-icon-upload el-icon--right"></i></el-button>
              <el-button  type="primary"  v-if ="qbView.selected"  size = "small" @click = "seeAnswer()" icon="el-icon-search">查看答案</el-button>
              <el-button  type="primary"   size = "small" icon="el-icon-arrow-left"  @click = "learnNextQb2(false)" >上一题</el-button>
              <el-button  type="primary"   style="el-icon--right"  size = "small"  @click = "learnNextQb2(true)" icon="">下一题 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button  type="primary"   style="el-icon--right"  size = "small"  @click = "leanNextUndoQb()" icon="">未学习 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div >
            <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer" >
              <el-tag type="warning">答案</el-tag>
              <span style ="margin-left: 10px;" > {{qbView.answer }}</span>
            </div >
            <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer">
              <el-tag type="warning"  >解析</el-tag>
              <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
            </div>
          </el-card>
        </el-col>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisual.viewPaperVisual" fullscreen  v-on:close ="clearPaperViewForm" >
        <el-col :span="7" style="">
          <el-card style="height:calc(25vh - 10px);margin-top: 10px;text-align: left; overflow:auto;">
            <div  class="clearfix">
              <el-tag type ="mini">
                {{ viewThemeOneDetail.theme }}
              </el-tag>
            </div>
            <div  class="clearfix">
              <el-tag type ="info" size = "mini" v-if="viewThemeOneDetail.usrState == 1" >
                未作答
              </el-tag>
              <el-tag type ="success" size = "mini" v-else-if="viewThemeOneDetail.usrState == 2" >
                考试中
              </el-tag>
              <el-tag type ="danger" size = "mini" v-else>
                已交卷
              </el-tag>
              <el-tag type ='primary' size="mini" v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver" style="cursor: pointer;" @click = savePaper(viewThemeOneDetail.id)>暂存</el-tag>
              <el-tag type ='warning' size="mini" v-if="viewThemeOneDetail.usrState == 2" style="cursor: pointer;" @click = sendPaper(viewThemeOneDetail.id)>交卷</el-tag>
              <el-tag :type ="viewThemeOneDetail.result == 0 ? 'danger': 'success'" size="mini" v-if="viewThemeOneDetail.usrState == 3">
                {{ viewThemeOneDetail.result == 0 ? '不合格': '合格' }}
              </el-tag>
              <el-tag type ="mini" v-if="viewThemeOneDetail.usrState == 3">
                {{ viewThemeOneDetail.score }} 分
              </el-tag>
            </div>
              <div>
                <span style="margin-top : 5px">总分数: {{ viewThemeOneDetail.totalScore }}分; </span>
                <span style="margin-top : 5px">及格分数:{{ viewThemeOneDetail.passScore }}分; </span>
                <span style="margin-top : 5px">考试时长:{{ viewThemeOneDetail.duration }}分钟; </span>
                <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
              </div>
              <div style="width: 100%; " v-if="viewThemeOneDetail.usrState == 3">
                <span>
                  答题时间: {{ viewThemeOneDetail.beginExamTime }}到{{ viewThemeOneDetail.commitExamTime }}
                </span>
              </div>
              <div style="width: 100%;" v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver">
                <el-tag type ="danger" size="mini" >
                考试时间还剩:
                </el-tag>
                <span>
                {{ timer.minutes }}分{{ timer.seconds }}秒
                </span>
              </div>
              <div style="width: 100%;" v-if="viewThemeOneDetail.usrState == 2 && viewThemeOneDetail.selfExamOver">
                <el-tag type ="danger" size="mini" >
                考试结束，请交卷
                </el-tag>
              </div>
          </el-card>
          <el-card style="height:calc(60vh - 10px); text-align: left; margin-top:calc(1vh);overflow:auto;">
            <div v-for = "(item,index) in viewThemeOneDetail.qtList" :key="index" style="margin-top:10px">
              <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
              <span >{{'每题' +item.oneScore+ '分,'}}</span>
              <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
              <el-checkbox-group v-model="viewPaperCheckList"  @change="selectedOne">
                <el-checkbox  v-for = "(ite,index) in item.qbList" :key="ite.id"  
                :label="ite.examQuestionId.toString()" :style = "answerCheckList['$$' +ite.examQuestionId ].length  == 0 ? 'color :rgb(208, 82, 82)': 'color:rgb(12, 239, 12)' "> 
                  {{index + 1}}  
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-card>
        </el-col>
        <el-col :span="17">
          <el-card style="height:calc(86vh - 19px); text-align: left; margin-top:10px;margin-left:20px; overflow:auto;">
            <div slot="header" class="clearfix">
            <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
            <el-tag>{{qbView.moduleName }}</el-tag>
            <el-tag type="success">{{qbView.answerCheckType }}</el-tag>
            <el-button type="danger"  v-if ="viewThemeOneDetail.usrState == 3 &&  qbView.learnAnswer != null&& qbView.learnAnswer != '' &&  qbView.learnAnswer != qbView.answer"   style="el-icon--right" @click="recordErrorQbExam()" size = "small" icon="">加入错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>         
          </div>
          <div style ="margin-top: 10px;">
            <el-tag type="warning">问题</el-tag>
            <span style ="margin-left: 10px;">{{qbView.question }}</span>
          </div>
          <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0"> 
            <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
            <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
              <el-image   
                style="width: 100px; height: 100px;margin-left: 10px; "
                :src="item.url"
                :fit="'fit'">
              </el-image>
            </el-badge>
          </div>
            <div style ="margin-top: 10px;">
              <el-checkbox-group v-model="answerCheckList['$$' + qbView.examQuestionId]" >
                <el-tag type="warning">选项</el-tag>
                <el-checkbox style ="margin-left: 10px;" :disabled = " !(viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver)"  v-for="(item,index ) in qbView.optionValueArr" :label="item.label" :key="index">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style ="margin-top: 10px;" v-if ="viewThemeOneDetail.usrState == 3" >
              <el-tag type="warning">我的答案</el-tag>
              <span v-if ="qbView.learnAnswer != null && qbView.learnAnswer != ''" style ="margin-left: 10px;">{{ qbView.learnAnswer }}</span>
              <span v-else>未作答</span>
              <el-button   style ="margin-left: 50px;" size="mini"  :type="qbView.learnAnswer == qbView.answer ? 'success':'danger'"
                :icon="qbView.learnAnswer == qbView.answer  ? 'el-icon-check': 'el-icon-close'" circle></el-button>
            </div>
            <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
              <el-tag type="warning">答案</el-tag>
              <span style ="margin-left: 10px;"> {{qbView.answer }}</span>
            </div >
            <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
              <el-tag type="warning">解析</el-tag>
              <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
            </div>
          </el-card>
        </el-col>
      </el-dialog>
    </div>
  </div>
</template>                        
<script>

import axios from  '@/api/axiosConfig'
import empty from "@/assets/image/empty.png"
import {MESSAGE_DURATION,fileType} from '@/api/constant'
import SERVICE_URL  from  '@/api/url'
import safeBook from "@/assets/image/safeBook.png"
import safeManage from "@/assets/image/safeManage.png"
import guid from "@/assets/image/guid.png"
import {convertDateFromString} from '@/api/utils'
// 引入组件
export default {
  name : 'pc_home',
  data() {
    return {
      empty,
      safeBook,
      safeManage,
      guid,
      src:"/static/image/el.svg",
      src1:"/static/image/head.jpeg",
      fit:"cover",
      localFileType:fileType,
      downLoad: {
        startTime:'' ,
        startTime:''
      },
      knColorList:["#f2853d","#00ffff","#00ff00","#c8dc16"],
      safeBookList: [],
      formInline: {
        nane: '',
        size: 10,
        current:1,
        totalCount:0,
      },
      enterState :{
          studyState : 0,
          loading : false
      },
      regBasicList  : [],
      knBasicList : [],
      qmBasic :{
        id :  0,
      },
      examThemeBasic :{
        id :0,
        examCount : 1,
        result : null
      },
      safeBookBasic :{
        id : 0
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      noticeList :[],
      knModelList :[],
      qmList: [],
      imagList: [],
      regObj:{
        countryList :[],
        localList :[],
        otherList: []
      },
      viewQbOneDetail: {
        moduleId :'',
        moduleName:'',
        totalCount : '',
        learnPer : 0,
        learnOkPer : 0,
        learnCount :'',
        learnOkCount : '',
        qtList :[]
      },
      dialogVisual :{
        viewPaperVisual :false,
        viewQbVisual :false
      },
      viewThemeOneDetail: {
        id : '',
        theme:'',
        // moduleName :'',
        usrState :'',
        score:'',
        beginExamTime :'',
        commitExamTime :'',
        result:'',
        totalScore:'',
        passScore:'',
        examState :'',
        selfExamOver :'',
        duration :'',
        qtList :[]
      },
      viewPaperCheckList:[],
      answerCheckList:{},
      qbView :{
        selected : false,
        examQuestionId :'',
        id:'',
        learnAnswer:'',
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        checkedOptList:[],
        answerCheckType :'',
        imageUrlList :[],

        //
        learnTime :'',
        resultOk: false,
        seeAnswer:false
      },
      timer:{
        noticeSignPaper: false,
        beginExamTime :'',
        timerId :'',
        minutes :'',
        seconds:'',
        duration :''
      },
      canReExam : true
    }
  },
  methods : {

    /**
     * 基础
     *
     */
    //  显示一条消息
    showMessage(message){
      this.$message({
        showClose: true,
        message: message,
        type: 'error',
        duration: MESSAGE_DURATION
      })
    },

    // 路由到父页面
    routeParent(index){
      window.parent.postMessage({
        data: index,
      }, '*');
    },

    // 个人中心本页面路由
    routeParentSelf(index,active){
      window.parent.postMessage({
        data: index, active,active
      }, '*');
    },

    // 打开一个新的页面
    routeFuncDetail(id,fileType){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open(SERVICE_URL + "/#/pc_editor_view/" +id +"?fileType=" + fileType,"test",params0);
    },

    // 路由到安全责任书
    routeFuncDetailSafeBook( id){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open( SERVICE_URL +"/#/pc_editor_view/" +id +"?fileType=" + fileType.SAFE_BOOK,"test",params0);
    },
    /**
     * 
     * 初始化
     * 
     * 
     */
     // 加载通知公告
    noticeListLoad(){
      let url = "/bc/exa/notice/noticePage"
      let dat0 = {
        pageSize: 6,
        pageNo:1,
        active : 1
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
              this.noticeList = [];
              dat.data.forEach(t=>this.noticeList.push(t))
          } 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },

    qmListLoad(pageNo){
      let url = "/bc/exa/qm/qmPage"
      let dat0 = {
          pageSize: 4,
          pageNo,
          active:1,
          adminInfInvoke: false
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
            this.qmList = []
            dat.data.forEach(t=>this.qmList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到知识题库信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },

    lbtListLoad(){
      let url = "/bc/exa/carousel/carouselPage"
      let dat0 = {
        pageSize: 5,
        active:1,
        pageNo:1
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
              this.imagList = []
              dat.data.forEach(t=>this.imagList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询轮播图信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },

    knListLoad(){
      let url = "/bc/exa/kn/knHomePage"
      let dat0 = {
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.length !== 0){
              this.knModelList = []
              dat.forEach(t=>this.knModelList.push(t))
          } 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },

    regListLoad(){
      let url = "/bc/exa/reg/regPage"
      let dat0 = {
          pageSize: 100,
          pageNo:1,
          adminInfInvoke : false
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableData = [];
              let subType = fileType.REGULATIONS.SUB_TYPE
              dat.data.forEach(t=>{
                if(subType.COUNTRY == t.type){
                  this.regObj.countryList.push(t)
                }else if (subType.LOCAL == t.type) {
                  this.regObj.localList.push(t)
                }else if(subType.OTHER == t.type){
                  this.regObj.otherList.push(t)
               }
              })
          } else {
            this.$message({
              showClose: true,
              message: '未查询到规章制度信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },

    safeBookListLoad(pageNo){
      let url = "/bc/exa/safeBook/selectUserSafeBookPage"
      let dat = {
        student:true,
        signState : 1,
        pageNo,pageSize : 5}
      let s = JSON.stringify(dat)  

      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.safeBookList.splice(0)
            response.data.data.data.forEach(t=>{
              this.safeBookList.push(t)
            })
            let safeBook = this.safeBookList.pop()
            let safeBookId = safeBook.id
            this.routeFuncDetailSafeBook(safeBookId)
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {

        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, // 当鼠标在 Canvas 上移动时触发

    /**
     * 全路由
     * 
     */
    // 路由到规章
    handleCommandReg(id){
      this.routeFuncDetail(id,'规章制度')
    },

    /**
     * 实验室准入教程
     * 
     */
    // 路由到准入教程安全知识
    handleCommandKn(id){
      if(this.enterState.studyState < 1){
        this.showMessage("请先学习实验室准入教程的规章制度")
        return
      }
      this.routeFuncDetail(id,'安全知识')
    },
    
    // 路由到准入安全知识题库
    goBasicQm(){
      if(this.qmBasic.id == 0){
        this.showMessage("未配置实验室准入安全知识题库")
        return
      }
      if(this.enterState.studyState < 2){
        this.showMessage("请先学习实验室准入教程的安全知识！")
        return
      }
      this.goSelfTest(this.qmBasic.id)
    },

    // 路由到准入教程安全考试（可查历史）
    handleCommandExam(examCount){

      if(this.examThemeBasic.id == 0){
        this.showMessage("未配置实验室准入安全考试！")
        return
      }
      if(this.enterState.studyState < 3){
        this.showMessage("请先学习实验室准入教程的知识题库！")
        return
      }

      if(examCount == 0){
        this.handleReExamPaper(this.examThemeBasic.id) 
      }else{
        console.log(examCount +"<=>" + this.examThemeBasic.examCount )
        if(examCount == this.examThemeBasic.examCount ){
          this.handleViewPaper(this.examThemeBasic.id , null)
        }else{
          this.handleViewPaper(this.examThemeBasic.id , examCount)
        }
      }
    },

    // 准入教程第一次进入考试
    goBasicExam(){
      if(this.examThemeBasic.id == 0){
        this.showMessage("未配置实验室准入安全考试！")
        return
      }
      if(this.enterState.studyState < 3){
        this.showMessage("请先学习实验室准入教程的知识题库！")
        return
      }
      this.handleViewPaper(this.examThemeBasic.id, null)
    },

    // 准入教程，路由到安全责任书
    goBasicSafeBook(){
      if(this.safeBookBasic.id == 0){
        this.showMessage("未配置实验室准入安全责任书！")
        return
      }
      if(this.enterState.studyState < 4){
        this.showMessage("请先完成实验室准入安全考试！")
        return
      }
      this.routeFuncDetailSafeBook(this.safeBookBasic.id)
    },

    // 准入教程，刷新
    refreshEnterState(){
      this.enterStateLoad( true)
    },


    // 准入教程，刷新
    enterStateLoad(refresh){
      if(this.enterState.loading){
        return
      }
      this.enterState.loading = true
      let url = "/bc/exa/enter/state"
      let dat0 = {
         
      }
      axios.post(url, dat0).then((response) => {
        this.enterState.loading = false
        if (response.data.code === 0) {
          console.log(response.data)
          this.canReExam = true
            if(refresh){
              this.$message({
              showClose: true,
              message:'刷新成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
          }
          this.enterState.studyState= 0
          this.regBasicList= []
          this.knBasicList= []
          this.qmBasic.id = 0
          this.examThemeBasic.id  = 0
          this.examThemeBasic.examCount  = 1
          this.examThemeBasic.result  = null
          this.safeBookBasic.id = 0
          let dat = response.data.data;
          if(dat.studyState != null ){
            this.enterState.studyState = dat.studyState
          }
          if(dat.bcRegLearnSearchVoList != null && dat.bcRegLearnSearchVoList.length > 0 ){
            dat.bcRegLearnSearchVoList.forEach(t=>{
              this.regBasicList.push(t)
            })
          }
          if(dat.bcKnLearnSearchVoList != null && dat.bcKnLearnSearchVoList.length > 0 ){
            dat.bcKnLearnSearchVoList.forEach(t=>{
              this.knBasicList.push(t)
            })
          }
          if(dat.bcQuestionModuleBasicVo != null ) {
            this.qmBasic.id = dat.bcQuestionModuleBasicVo.id
          }
          if(dat.bcExamThemeBasicVo != null ) {
            this.examThemeBasic.id = dat.bcExamThemeBasicVo.id
            if(dat.bcExamUserEntity != null){
              this.examThemeBasic.examCount =  dat.bcExamUserEntity.examCount
              if(dat.bcExamUserEntity.result != null){
                this.examThemeBasic.result = dat.bcExamUserEntity.result == 1
              }
            }
          }

          if(dat.bcSafeBookBasicVo != null ) {
            this.safeBookBasic.id = dat.bcSafeBookBasicVo.id
          }

        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.enterState.loading = false
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },


    /**
     * 知识题库
     * 
     */

    // 已答题
    funcAnswered(percentage){
      return '已答' + percentage +'%'
    },

    // 正确率
    funcOk(percentage){
      return '正确' + percentage +'%'
    },


    // 查看答案开关
    seeAnswer(){
      this.qbView.seeAnswer = true
    },

    // 进入知识题库学习页面
    goSelfTest(id){
      this.dialogVisual.viewQbVisual = true
      this.viewQbOneDetail.moduleId = id
      setTimeout(()=>{this.qbLearnOneModuleSum(id)},200)
      setTimeout(()=>{this.leanNextQb(id,0,true)},200)
    },

    // 知识题库学习提交答案
    submitAnswer(){
      if(this.qbView.checkedOptList.length == 0){
        this.$message({
          showClose: true,
          message: '请选择答案！',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let answer = this.qbView.checkedOptList.sort().join("") 
      let url = "/bc/exa/qb/leanCommitAnswerQb"
      let dat0 = { qbId:this.qbView.id, answer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.qbView.selected = true
          this.qbView.learnAnswer = answer
          if(answer == this.qbView.answer ){
            this.qbView.resultOk = true
          }else {
            this.qbView.resultOk = false
          }
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    // 一个知识题库模块学习情况
    qbLearnOneModuleSum(id){
      let url = "/bc/exa/qb/qbLearnOneModuleSum"
      let dat0 = { id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.viewQbOneDetail.moduleName = dat.moduleName
          this.viewQbOneDetail.totalCount = dat.totalCount
          this.viewQbOneDetail.learnOkCount = dat.learnOkCount
          this.viewQbOneDetail.learnCount = dat.learnCount
          if(dat.totalCount != 0 ){
              this.viewQbOneDetail.learnOkPer =  Math.floor( 100 *  dat.learnOkCount /  dat.totalCount )
              this.viewQbOneDetail.learnPer =  Math.floor( 100 * dat.learnCount / dat.totalCount )
          }
          
          if(dat.qtList != null && dat.qtList.length != 0){
            dat.qtList.forEach(t=>{
              this.viewQbOneDetail.qtList.push({
                count:t.count,
                learnCount:t.learnCount,
                learnOkCount:t.learnOkCount,
                answerCheckType:t.answerCheckType
              })
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    // 知识题库下一题反向
    learnNextQb2(asc){
      this.qbView.seeAnswer = false
      this.leanNextQb( this.viewQbOneDetail.moduleId, this.qbView.id,asc)
    },
    // 知识题库下一个题目
    leanNextQb(id,curQbId,asc){
      let url = "/bc/exa/qb/leanNextQb"
      let dat0 = {moduleId:id, curQbId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },

    // 加入一个书签
    recordOneSchedule(){
      let url = "/bc/exa/qb/recordOneSchedule"
      let dat0 = {moduleId:this.viewQbOneDetail.moduleId, qbId:this.qbView.id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入书签成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })

        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },

    // 下一个为未学习的题目
    leanNextUndoQb(){
      if(!this.qbView.selected) {
        this.$message({
          showClose: true,
          message: '当前题目未作答',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/qb/leanNextUndoQb"
      let dat0 = {id: this.viewQbOneDetail.moduleId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },


    // 关闭安全知识学习弹框，清除数据
    clearViewQbOneDetail(){
      // this.dialogVisual.viewQbVisual = false
      this.viewQbOneDetail.learnPer = 0
      this.viewQbOneDetail.learnOkPer = 0
      this.viewQbOneDetail.moduleId = ''
      this.viewQbOneDetail.moduleName = ''
      this.viewQbOneDetail.totalCount  = ''
      this.viewQbOneDetail.learnCount  = ''
      this.viewQbOneDetail.learnOkCount  = ''
      this.viewQbOneDetail.qtList.splice(0)
      this.clearViewQbForm()
    },

    // 清除考试题目数据
    clearViewQbForm(){
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.uniqNo = ''
      this.qbView.answerCheckType = ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
      this.qbView.checkedOptList.splice(0)
      this.qbView.learnAnswer = ''
      this.qbView.id = ''
      this.qbView.selected = false,
      this.qbView.resultOk = false,
      this.qbView.learnTime = '',
      this.qbView.seeAnswer = false,

      this.qbView.examQuestionId = ''
    },

    // 安全知识，加入错题集
    recordErrorQb(){
      if( !this.qbView.selected){
        this.$message({
          showClose: true,
          message: '该题目未作答，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }

      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      
      
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    }, 

    /**
     *  考试
     * 
     */
    // 加入错题集
    recordErrorQbExam(){
       if(this.viewThemeOneDetail.usrState != 3){
        this.$message({
          showClose: true,
          message: '未交卷，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      
      
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    }, 
 
    // 考试计时器
    timerFunc(){
      if(this.timer.seconds == '' || this.timer.seconds == 0){
        //const startTime = new Date( this.timer.beginExamTime)
        const startTime =  convertDateFromString(this.timer.beginExamTime)
        const endTime = new Date();
        const timeDiff = (startTime.getTime()  + this.timer.duration * 1000 * 60 ) - endTime.getTime()
        if (timeDiff < 0 ){
          this.viewThemeOneDetail.selfExamOver = true
        }else{
          const totalSeconds =  Math.floor(timeDiff / 1000)
          console.log("totalSeconds==" + totalSeconds)
          if(!this.timer.noticeSignPaper && totalSeconds < 3 * 60) {
              this.$message({
              showClose: true,
              message: '离考试结束时间不到3分钟，请尽快交卷！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
            this.timer.noticeSignPaper = true
          }
          this.timer.minutes = Math.floor(totalSeconds / 60)
          this.timer.seconds = Math.floor(totalSeconds % 60)
          console.log("minutes==" + this.timer.minutes)
          console.log("seconds==" + this.timer.seconds)

        }
      }else{
        this.timer.seconds = this.timer.seconds  - 1
      }
    },
    
    // 直接提交考试
    // handleCommitPaper(examId){
    //   let url = "/bc/exa/exam/examCommitPaper"
    //   let dat ={
    //     themeId:examId,student:true
    //   }
    //   let s = JSON.stringify(dat)  
    //   axios.post(url, s).then((response) => {
    //     if (response.data.code === 0){
    //       this.$message({
    //         showClose: true,
    //         message: response.data.message,
    //         type: 'success',
    //         duration: MESSAGE_DURATION
    //       }) 
    //     }else{
    //       this.$message({
    //         showClose: true,
    //         message: response.data.message,
    //         type: 'error',
    //         duration: MESSAGE_DURATION
    //       })
    //     }
    //   }).catch( (err) => {
    //     this.$message({
    //         showClose: true,
    //         message: err.message,
    //         type: 'error',
    //         duration: MESSAGE_DURATION
    //     }) 
    //   })
    // },
    
    // 交卷准备和询问
    sendPaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      let count  = 0
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) ;
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length == 0){
          count++ 
        }else{
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({ examQuestionId, answer:learnAnswer})
        }
      }
      let message = "请确认是否交卷？"
      if(count != 0){
        message = "检查到还有" + count  + "个题目未作答,请确认是否交卷？"
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSendPaper(themeId,answerArr)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消！'
        });
      })
    },
    // 交卷
    doSendPaper(themeId,dat){
      let url = "/bc/exa/exam/examSendPaper/" + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
          this.dialogVisual.viewPaperVisual = false
          this.clearPaperViewForm()
          //setTimeout(()=>{this.this.examListLoad(1)},200)
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },

    // 暂存试卷和准备
    savePaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) 
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length != 0){
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({examQuestionId, answer:learnAnswer})
        }
      }
      if(answerArr.length == 0 ){
        this.$message({
          showClose: true,
          message: '您还未开始答题',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      this.$confirm('是否要暂存考试答案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSavePaper(themeId,answerArr)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消提交！'
        });
      })
    },

    // 暂存试卷
    doSavePaper(themeId,dat){
      let url = "/bc/exa/exam/examSavePaper/" + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },


    // 清除定时器
    clearTimer (){
      if(this.timer.timerId != ''){
        clearInterval(this.timer.timerId)    
        this.timer.beginExamTime = ''
        this.timer.timerId  = ''
        this.timer.minutes = ''
        this.timer.seconds = ''
        this.timer.duration = ''
      }
    },
    
    // 关闭页面
    clearPaperViewForm(){    
      this.clearTimer()
      this.answerCheckList = {}
      this.viewThemeOneDetail.id = ''
      // this.viewThemeOneDetail.moduleName = ''
      this.viewThemeOneDetail.usrState = ''
      this.viewThemeOneDetail.score = ''
      this.viewThemeOneDetail.beginExamTime = ''
      this.viewThemeOneDetail.commitExamTime = ''
      this.viewThemeOneDetail.examState = ''
      this.viewThemeOneDetail.id = ''
      this.viewThemeOneDetail.selfExamOver = ''
      this.viewThemeOneDetail.theme = ''
      this.viewThemeOneDetail.totalScore = ''
      this.viewThemeOneDetail.passScore = ''
      this.viewThemeOneDetail.duration = ''
      this.viewPaperCheckList.splice(0)
      this.viewThemeOneDetail.qtList.splice(0)
      this.clearViewQbForm()
    },

    // 重新考试
    handleReExamPaper(id){
      let dat = {
        themeId : id 
      }
      let url = "/bc/exa/themeUser/reExam"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.handleViewPaper(this.examThemeBasic.id , null)
          this.canReExam = false
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },


    // 打开一个试卷
    handleViewPaper( id,examCount){
      this.dialogVisual.viewPaperVisual = true
      let dat = {
        id,
        student:true,
        examCount 
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let dat = response.data.data
          // this.viewThemeOneDetail.moduleName = dat.moduleName
          this.viewThemeOneDetail.usrState = dat.usrState
          this.viewThemeOneDetail.score = dat.score
          this.viewThemeOneDetail.beginExamTime = dat.beginExamTime
          this.viewThemeOneDetail.commitExamTime = dat.commitExamTime
          this.viewThemeOneDetail.examState = dat.examState
          this.viewThemeOneDetail.result = dat.result
          this.viewThemeOneDetail.id = dat.id
          this.viewThemeOneDetail.theme = dat.theme
          this.viewThemeOneDetail.totalScore = dat.totalScore
          this.viewThemeOneDetail.passScore = dat.passScore
          this.viewThemeOneDetail.duration = dat.duration
          this.viewThemeOneDetail.selfExamOver  = dat.selfExamOver
          this.viewThemeOneDetail.qtList.splice(0)
          this.viewThemeOneDetail.qtList = [... dat.qtList]
          this.viewPaperCheckList = []
    
          // 正在考试并且未超时
          if(this.viewThemeOneDetail.usrState == 2 &&  !this.viewThemeOneDetail.selfExamOver) {
            this.timer.beginExamTime = response.data.data.beginExamTime
            this.timer.duration = dat.duration
            this.timer.timerId = setInterval(this.timerFunc,1000)
          }
          
          let first = this.viewThemeOneDetail.qtList[0].qbList[0].examQuestionId
          for(let  i = 0 ;i< this.viewThemeOneDetail.qtList.length ; i++){
            let qt =this.viewThemeOneDetail.qtList[i]
            for(let  j = 0 ;j< qt.qbList.length ; j++){
              let qb = qt.qbList[j]
              let arr = []
              // 保证动态绑定
              if(dat.usrState >= 2 && qb.learnAnswer != null && qb.learnAnswer != ''){
                arr = [... qb.learnAnswer]
              }
              this.$set(this.answerCheckList,'$$' + qb.examQuestionId,arr)
            }
          }
          setTimeout(()=> this.handleViewQb(first.toString()),300)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    // 选择一个题目
    handleViewQb(last){
      this.viewPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewThemeOneDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++){
          if( qbList[j].examQuestionId == last ){
            row = qbList[j]
            break
          }
        }
      }
      this.qbView.id = row.id
      this.qbView.examQuestionId = row.examQuestionId
      this.qbView.analysis = row.analysis
      this.qbView.answer = row.answer
      this.qbView.question = row.question 
      this.qbView.moduleName=row.moduleName
      this.qbView.learnAnswer=row.learnAnswer
      this.qbView.uniqNo=row.uniqNo
      this.qbView.answerCheckType =row.answerCheckType
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbView.optionValueArr.push(  {  label :ch , name: ch + "."+ v + ";"}  )
        }
      }
      for(let i = 0; i< row.countImage; i++){
        this.qbView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },


    // 题目列表单选框点击
    selectedOne( val){
      this.clearViewQbForm()
      let last= this.viewPaperCheckList.pop()
      this.viewPaperCheckList = []
      setTimeout(()=> this.handleViewQb(last),200)
    },


    
    goOuterWeb(item){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100,location=no`;
      window.open( "http://www.baidu.com","test",params0);
    }

  },
  components: {
  },
  created() {

    //setTimeout(()=>{ this.safeBookListLoad(1) },200)
    
    setTimeout(()=>{ this.noticeListLoad() },200)

    setTimeout(()=>{ this.lbtListLoad() },200)

    setTimeout(()=>{ this.knListLoad() },200)

    setTimeout(()=>{ this.qmListLoad(1) },200)

    setTimeout(()=>{ this.regListLoad(1) },200)

    setTimeout(()=>{ this.enterStateLoad(false ) },200)
  }
}
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  padding: auto;
  background-color:#fff;
  // background-color:#f9fafc;
  color: #333;
  text-align: center;
  height: calc( 100vh - 30px );
  overflow:auto;
}
.carousel-item-text {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: rgb(255, 255, 255);

  padding: 10px;
  box-sizing: border-box;
  text-align: left;
}
.carousel-item-text  span {
  margin-top: 0;
  margin-bottom: 10px;
}


.el-row {
  padding: auto;
  margin: auto;
  height: 300px;
  width: 1400px;
  font-size: large;
  text-align: center;
}
.el-row-titile{
  padding: auto;
  margin: auto;
  height: 10px;
  width: 1400px;
  font-size: large;
  text-align: center;
}
.el-col-1{
  margin: 5px;
  border-radius:5px;
  background-color:#fff;
  .tzgg-ul{
    cursor: pointer;
    &:first-child {
      margin-top: 20px;
    }
    height: 200px;
    .tzgg-ul-li{
      cursor: pointer;
      height: 40px;
      line-height: 20px;
      margin:5px;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background: #6F6F6F;
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:65%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
      span{
        width:25%;
        display:inline-block;
        font-size: 1em;
        color: #6F6F6F;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
  
.el-col-2{
  margin: 25px;
  .m2{
    line-height: 40px;
    text-align: center;
    margin-top: 10px;
    a {
      cursor: pointer;
      overflow: hidden;
      padding-left: 1.5em;
      padding-right: 1.5em;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      text-align: center;
      font-size: 1em;
    }
  }
}
.el-col-3{
  margin: 5px;
  border-radius:5px;
  background-color:#fff;
  
  .tzgg-ul{
    &:first-child {
      margin-top: 20px;
    }
    .tzgg-ul-li{
      cursor: pointer;
      text-align: left;
      height: 40px;
      line-height: 20px;
      margin:3px;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background: #6F6F6F;
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:85%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
    }
  }
}
  
.text {
  font-size: 16px;
  color: #000;
}

.el-main-1::-webkit-scrollbar {
  width: 0px; // 横向滚动条
  height: 0px; // 纵向滚动条 必写
}
.el-main-1::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}


</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_home.vue